import { AudienceOption } from '@openx/types/targeting/audience.ts';
import type { UseAudienceOptionsFetchFn } from '@openx/types/targeting/targetingHookTypes.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';
import { useDmpSegmentsOptionsFetch } from './useDmpSegmentsOptionsFetch.ts';

export const useAudienceOptionsFetch: UseAudienceOptionsFetchFn = (accountUid: string, type: AudienceOption | null) => {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      filter: {
        account_uid: accountUid,
      },
      path: 'deal.package.targeting.audience.openaudience_custom',
    },
  });

  const audienceById = useMemo(() => {
    return optionsByPath.reduce((acc, option) => {
      if (option) {
        acc[option.id] = { ...option, ...option.extra };
      }

      return acc;
    }, {});
  }, [optionsByPath]);

  const dmpSegments = useDmpSegmentsOptionsFetch(accountUid);

  return useMemo(() => {
    if (type && type !== AudienceOption.LIVEINTENT) {
      return {
        [AudienceOption.DMP_SEGMENTS]: {
          isLoading: dmpSegments.loading,
          options: dmpSegments.mapById,
          refetch: dmpSegments.refetch,
        },
        [AudienceOption.OPEN_AUDIENCES]: {
          isLoading: loading,
          options: audienceById,
          refetch: refetch,
        },
      }[type];
    }
    return { isLoading: false, options: {} };
  }, [audienceById, loading, refetch, dmpSegments.mapById, dmpSegments.loading, dmpSegments.refetch, type]);
};
